<template>
  <div class="fixbo" v-if="pageFlag">
    <!-- 新人领取弹窗 -->
    <van-popup v-model="show1">
      <div class="myPopup">
        <img src="/images/home/newGift_1.png" @click="receiveGift" />
        <img
          src="/images/home/newGift_close.png"
          @click="show1 = false"
          class="close1"
        />
      </div>
    </van-popup>

    <!-- 领取成功弹窗 -->
    <van-popup v-model="show2">
      <div class="myPopup1">
        <img src="/images/home/redBag.png" @click="toGift" />
        <img :src="couponImg" class="vc-code" />
        <img
          src="/images/home/newGift_close.png"
          @click="show2 = false"
          class="close"
        />
      </div>
    </van-popup>

    <!-- 不能领取弹窗 -->
    <van-popup v-model="showNot">
      <div class="myPopup">
        <img src="/images/home/newGift_no.png" />
        <img
          src="/images/home/newGift_close.png"
          @click="showNot = false"
          class="close"
        />
      </div>
    </van-popup>

    <!-- 右边的 -->
    <div v-if="rightShow" class="rightBox">
      <img @click="rightBtn" src="/images/home/newGift_2.png" />
    </div>
  </div>
</template>

<script>
import myApi from "@/axios/my";
import { Dialog } from "vant";
import { mapState } from "vuex";
import zhugeObj from "@/assets/js/track";
export default {
  name: "new-gift",
  props: {
    // selected: {
    //   type: Boolean
    // },
  },
  data() {
    return {
      isChangPage:false,
      show1: false,
      show2: false,
      rightShow: false,
      showNot: false,
      pageFlag: true,
      token: this.$store.state.token,
      couponImg: "",
      pagesNames: [
        "/home",
        "/serviceDetail",
        "/homeListNew",
        "/case",
        "/feeScale",
        "/scope"
      ],
      hidePages: [
        "/mentionMe/recipt-index",
        "/mentionMe/send-index",
        "/game/doll"
      ],
      isNewGift: sessionStorage.getItem("newGift")
        ? JSON.parse(sessionStorage.getItem("newGift"))
        : false
    };
  },
  watch: {
    "$store.state.token": function(newValue, oldValue) {
      this.token = newValue;
    },
    $route(to, from) {
      console.log(3333)
      console.log(this.$route)
      if(this.isChangPage){
        this.getIsNew();
      }
      this.isChangPage = true
      // if (to.path === '/home' || to.path === '/login') {

      // }
    }
  },
  mounted() {},
  computed: {},

  created() {
    this.getIsNewdialog();
  },
  methods: {
    rightBtn() {
      this.show1 = true;
      let pathname = window.location.pathname;
      zhugeObj.track({
        title: "新人礼包-浮层点击",
        content: {
          pageUrl: pathname
        }
      });
      zhugeObj.track({
        title: "新人礼包-弹窗曝光",
        content: {
          pageUrl: pathname
        }
      });
    },
    dialogPages() {
      let pathname = window.location.pathname;
      for (let index in this.pagesNames) {
        if (pathname == this.pagesNames[index]) {
          return index;
        }
      }
    },
    receiveGift() {
      let pathname = window.location.pathname;
      let index = this.dialogPages();
      index = index > 1 ? 2 : index;
      zhugeObj.track({
        title: "新人礼包-点击立即领取",
        content: {
          pageUrl: pathname
        }
      });
      if (!this.token) {
        sessionStorage.setItem("newGift", true);
      }
      myApi
        .receiveGift()
        .then(res => {
          this.show1 = false;
          this.rightShow = false;
          this.show2 = true;
          this.couponImg = res[index];
          zhugeObj.track({
            title: "新人礼包-领取成功",
            content: {
              pageUrl: pathname
            }
          });
        })
        .catch(res => {
          if (res.code != 401) {
            zhugeObj.track({
              title: "新人礼包-领取失败",
              content: {
                pageUrl: pathname
              }
            });
          }
        });
    },
    getShowCode() {
      myApi.getIsNew().then(res => {
        let code = res.customerType,
          isPopUp = res.isPopUp;
        if (isPopUp) {
          if (code === 10) {
            // 新用户
            this.show1 = true;
            this.rightShow = true;
            zhugeObj.track({
              title: "新人礼包-浮层曝光",
              content: {
                url: pathname
              }
            });
            zhugeObj.track({
              title: "新人礼包-弹窗曝光",
              content: {
                url: pathname
              }
            });
          } else if (code === 20) {
            // 新用户，但已领取过
            Dialog.alert({
              message: "您已领取过新人礼包～"
            });
          } else if (code === 30) {
            // 老用户
            this.showNot = true;
          }
        } else {
          if (this.isNewGift) {
            if (code === 10) {
              // 新用户
              this.show1 = true;
              this.rightShow = true;
              zhugeObj.track({
                title: "新人礼包-浮层曝光",
                content: {
                  url: pathname
                }
              });
              zhugeObj.track({
                title: "新人礼包-弹窗曝光",
                content: {
                  url: pathname
                }
              });
            } else if (code === 20) {
              // 新用户，但已领取过
              Dialog.alert({
                message: "您已领取过新人礼包～"
              });
            } else if (code === 30) {
              // 老用户
              this.showNot = true;
            }
            sessionStorage.setItem("newGift", false);
            this.isNewGift = false;
          }
        }
      });
    },
    getIsNewdialog() {
      let pathname = window.location.pathname;
      this.show1 = false;
      this.rightShow = false;
      if (this.token) {
        for (let page of this.pagesNames) {
          if (pathname == page) {
            this.getShowCode();
          }
        }
      } else {
        for (let page of this.pagesNames) {
          if (pathname == page) {
            this.show1 = true;
            this.rightShow = true;
            zhugeObj.track({
              title: "新人礼包-浮层曝光",
              content: {
                url: pathname
              }
            });
            zhugeObj.track({
              title: "新人礼包-弹窗曝光",
              content: {
                url: pathname
              }
            });
          }
        }
      }
    },
    getIsNew() {
      let pathname = window.location.pathname;
      this.rightShow = false;
      if (this.token) {
        for (let page of this.pagesNames) {
          if (pathname == page) {
            this.getShowCode();
          }
        }
      } else {
        for (let page of this.pagesNames) {
          if (pathname == page) {
            this.rightShow = true;
            zhugeObj.track({
              title: "新人礼包-浮层曝光",
              content: {
                url: pathname
              }
            });
            zhugeObj.track({
              title: "新人礼包-弹窗曝光",
              content: {
                url: pathname
              }
            });
          }
        }
      }
      this.show1 = false;
    },

    toGift() {
      let pathname = window.location.pathname;
      this.show2 = false;
      if (pathname !== "/my/couponList") {
        this.$router.push({ name: "couponList" });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.van-popup {
  background: transparent;
}

.fixbo {
  .myPopup {
    width: 542px;
    margin: 0 auto;
    img {
      display: block;
      width: 542px;
      height: 658px;
    }
    .vc-code {
      width: 248px;
      height: 248px;
      position: relative;
      left: calc(50% - 124px);
      top: -360px;
    }
    .close {
      margin: 32px auto 0;
      display: block;
      width: 60px;
      height: 60px;
      bottom: 200px;
      position: relative;
    }
    .close1 {
      margin: 32px auto 0;
      display: block;
      width: 60px;
      height: 60px;
    }
  }
  .myPopup1 {
    width: 646px;
    margin: 0 auto;
    img {
      display: block;
      width: 646px;
      height: 862px;
    }
    .vc-code {
      width: 348px;
      height: 348px;
      position: absolute;
      left: calc(50% - 174px);
      top: 380px;
    }
    .close {
      margin: 32px auto 0;
      display: block;
      width: 60px;
      height: 60px;
    }
    .close1 {
      margin: 32px auto 0;
      display: block;
      width: 60px;
      height: 60px;
    }
  }
  .rightBox {
    position: fixed;
    right: 10px;
    width: 118px;
    height: 96px;
    z-index: 1900;
    bottom: 400px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .cancel {
      width: 30px;
      height: 30px;
      position: absolute;
      z-index: 1;
    }
  }
}
</style>
